import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      marginBottom: 24,
      [mediaQuery(breakpoints.laptop)]: {
        padding: [0, 24],
      },
    },
    label: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
    },
    webLabel: {
      display: 'block',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
    mobileLabel: {
      display: 'none',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'block',
      },
    },
  }),
  {
    name: 'choices',
  },
);

export default useStyles;
